<ion-list class="buttons-list" [ngClass]="{ 'application-padding': applicationDetails }">
    <ion-item lines="none" class="seats-container">
        <ion-label class="ion-text-center">
            <div class="flex">
                <fa-icon [icon]="icons.pennant" slot="start" class="small-text orange fa-line-padding" *ngIf="programDetails && !applicationDetails"></fa-icon>
                <div class="note-text inline" *ngIf="program?.offered > 1">{{ program?.offered }} seats offered!</div>
                <div class="bold note-text inline danger" *ngIf="program?.offered === 1">{{ program?.offered }} seat offered!</div>
                <div class="bold note-text inline danger" *ngIf="program?.offered === 0">No seats offered!</div>
            </div>
            <div class="small-text orange inline" color="primary" *ngIf="applicationDetails && !programDetails">
                Your application status:<br />
                <fa-icon [icon]="icons.calendar" class="date-icon"></fa-icon>&nbsp;
                <div class="bold-text inline">
                    {{ applicationState | uppercase }}
                </div>
            </div>
        </ion-label>
    </ion-item>
    <hr class="buttons-divider" />
    <ion-button class="ion-text-wrap ion-justify-content-center" fill="clear" (click)="LinktoFAQ()" color="light-teal-button" *ngIf="!(censorContent$ | async)">
        <fa-icon slot="start" [icon]="icons.question" class="fa-line-padding"></fa-icon>
        &nbsp;<span class="note-text text-teal">Read our FAQ</span>
    </ion-button>
    <div *ngIf="!(censorContent$ | async)">
        <ion-button
            *ngIf="
                application?.states === 'Pending' ||
                application?.states === 'Pre-Approved' ||
                application?.states === 'Accepted' ||
                application?.states === 'Pending-Booked'
            "
            (click)="contactAdvisorFunction($event)"
            class="ion-text-wrap ion-justify-content-start"
            fill="clear"
            color="light-teal-button"
        >
            <fa-icon slot="start" [icon]="icons.phone" class="fa-line-padding"></fa-icon>
            <span class="note-text text-teal">Reach an advisor</span>
        </ion-button>
    </div>
    <div *ngIf="!(censorContent$ | async)">
        <ion-button
            *ngIf="application?.states === 'Reserved' || application?.states === 'Enrolled'"
            (click)="contactCoachFunction($event)"
            class="ion-text-wrap ion-justify-content-start"
            fill="clear"
            color="light-teal-button"
        >
            <fa-icon slot="start" [icon]="icons.exclamation" class="fa-line-padding"></fa-icon>
            <span class="note-text text-teal">Contact a coach</span>
        </ion-button>
    </div>

    <ion-button
        *ngIf="application?.id && (application?.states === 'Pending' || application?.states === 'Pre-Approved' || application?.states === 'Accepted')"
        (click)="cancelApplication(application?.id)"
        class="ion-text-wrap ion-justify-content-start danger"
        fill="clear"
    >
        <fa-icon slot="start" [icon]="icons.exclamation" class="fa-line-padding"></fa-icon>
        <span class="note-text text-teal">Cancel application</span>
    </ion-button>
</ion-list>
